// @flow

import React, { PureComponent } from "react";
import { noop } from "lodash";
import Icon from "@fdr/static-ui/Icons";
import { caretUp } from "@fdr/static-ui/Icons/icons";
import buildColor from "@fdr/static-ui/ColorPalette";
import { type UnaryFn, type NullaryFn } from "@tvg/types/Functional";
import { type SortTypeEnum } from "@fdr/types/ProgramPage";
import {
  InformationContainer,
  HorseDetails,
  SortType
} from "./styled-components";

type Props = {
  sortType: SortTypeEnum,
  onSortModalClick: UnaryFn<SortTypeEnum, void>,
  openAllRunners: NullaryFn<void>,
  isAllRunnersOpen: boolean
};

export default class RaceCardSort extends PureComponent<Props> {
  static defaultProps = {
    sortType: "odds",
    onSortModalClick: noop,
    openAllRunners: noop,
    isAllRunnersOpen: false
  };

  render() {
    return (
      <InformationContainer>
        <HorseDetails onClick={this.props.openAllRunners}>
          {!this.props.isAllRunnersOpen ? "show" : "hide"} horse details
        </HorseDetails>
        <SortType onClick={this.props.onSortModalClick}>
          SORT BY {this.props.sortType}
          <Icon icon={caretUp} color={buildColor("blue", "D1")} />
        </SortType>
      </InformationContainer>
    );
  }
}
